import { render } from "./AgendaSalaView.vue?vue&type=template&id=09215e18&scoped=true"
import script from "./AgendaSalaView.vue?vue&type=script&lang=js"
export * from "./AgendaSalaView.vue?vue&type=script&lang=js"

import "./AgendaSalaView.vue?vue&type=style&index=0&id=09215e18&scoped=true&lang=css"
import "./AgendaSalaView.vue?vue&type=style&index=1&id=09215e18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09215e18"]])

export default __exports__